import { combineReducers } from 'redux';
import { createDataReducer } from '../../store/dataReducer';
import { createRequestReducer } from '../../store/requestReducer';
import * as actions from './projectActions';

export const initialFilterState = null;
export const initialState = {}

export const isProjectMetadataView = {
  metaDataViewOpen: false,
  selectedDocument: null,
}

export function setProjectMetaDataView(state = isProjectMetadataView, action = {}) {
  switch (action.type) {
    case actions.SET_METADATA_VIEW:
        return {
          metaDataViewOpen: action.metaDataView,
          selectedDocument: action.document,
        }
    default:
      return state;
  }
}

export const initialStatusState = {
  latestStatus: null,
  statusHistory: {
    records: [],
    totalCount: 0,
  },
  loading: false,
  error: null,
};

export function projectStatusReducer(state = initialStatusState, action = {}) {
  switch (action.type) {
    case actions.SET_LATEST_STATUS:
      return {
        ...state,
        latestStatus: action.data,
      };
    case actions.SET_STATUS_HISTORY:
      return {
        ...state,
        statusHistory: {
          records: action.records,
          totalCount: action.totalCount,
        },
      };
    case actions.APPEND_STATUS_HISTORY:
      return {
        ...state,
        statusHistory: {
          records: [...state.statusHistory.records, ...action.records],
          totalCount: action.totalCount,
        },
      };
    case actions.RESET_STATUS_HISTORY:
      return {
        ...state,
        statusHistory: {
          records: [],
          totalCount: 0,
        },
      };
    case actions.STATUS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case actions.STATUS_ERROR:
      return {
        ...state,
        error: action.error ? action.error.message : null,
      };
    default:
      return state;
  }
}

export const recipientsInitialState = [];
export function recipientsReducer(state = recipientsInitialState, action = {}) {
  switch (action.type) {
    case actions.SET_RECIPIENTS:
      return action.recipients;
    default:
      return state;
  }
}

export const emailNotificationHistoryInitialState = [];
export function emailNotificationHistoryReducer(state = emailNotificationHistoryInitialState, action = {}) {
  switch (action.type) {
    case actions.SET_PROJECT_EMAIL_NOTIFICATION_HISTORY:
      return action.history;
    default:
      return state;
  }
}

export const emailNotificationSendStatusInitialState = {
  loading: false,
  response: null,
  error: null,
};

export function emailNotificationSendStatusReducer(
  state = emailNotificationSendStatusInitialState,
  action = {},
) {
  switch (action.type) {
    case actions.SEND_EMAIL_NOTIFICATION:
      return {
        loading: true,
        response: null,
        error: null,
      };
    case actions.SEND_EMAIL_NOTIFICATION_SUCCESS:
      return {
        loading: false,
        response: action.response,
        error: null,
      };
    case actions.SEND_EMAIL_NOTIFICATION_ERROR:
      return {
        loading: false,
        response: null,
        error: action.error,
      };
    case actions.RESET_EMAIL_NOTIFICATION_SEND_STATUS:
      return emailNotificationSendStatusInitialState;
    default:
      return state;
  }
}

export default combineReducers({
  data: createDataReducer({
    SET_DATA: actions.SET_DATA,
  }),
  request: createRequestReducer({
    ERROR: actions.ERROR,
    LOADING: actions.LOADING,
  }),
  projectMetaDataView: setProjectMetaDataView,
  status: projectStatusReducer,
  recipients: recipientsReducer,
  emailNotificationHistory: emailNotificationHistoryReducer,
  emailNotificationSendStatus: emailNotificationSendStatusReducer,
});
